import { Model, table, index, primary } from '@tencent/memoire-structured-storage';
import type { SnapshotMeta } from '../definitions';

@table('SnapshotMetaItems')
export class SnapshotMetaItemsModel extends Model implements SnapshotMeta {
    public static fromSnapshotMeta(meta: SnapshotMeta, size: number) {
        return new this({ ...meta, createdAt: new Date().toISOString(), size });
    }

    @primary()
    public id: string;

    @index()
    public globalPadId: string;

    @index()
    public userId: string;

    @index()
    public createdAt: string;

    @index()
    public size: number;

    public constructor({
        id,
        globalPadId,
        userId,
        createdAt,
        size,
    }: {
        id: string;
        globalPadId: string;
        userId: string;
        createdAt: string;
        size: number;
    }) {
        super();

        this.id = id;
        this.globalPadId = globalPadId;
        this.userId = userId;
        this.createdAt = createdAt;
        this.size = size;
    }
}
